export class Product {
  constructor(
    technicalId,
    boomerangId,
    boomerangName,
    length,
    width,
    weight,
    reparable,
    comment,
    productType,
    picture,
    serialNumberPicture,
    modelSerialNumber
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.boomerangName = boomerangName
    this.length = length
    this.width = width
    this.weight = weight
    this.reparable = reparable
    this.comment = comment
    this.productType = productType
    this.picture = picture
    this.serialNumberPicture = serialNumberPicture
    this.modelSerialNumber = modelSerialNumber
  }
}
